module.exports = __webpack_public_path__ + "static/img/activity_banner_pc.66dd83f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity_banner_pc.jpg
// module id = QojP
// module chunks = 1